import { Navigate, useSearchParams } from "react-router-dom";
import { NoActiveRaffle } from "../home/NoActiveRaffle";
import { Loading } from "../layout/loading";
import { SuccessPurchase } from "../home/SuccessPurchase";
import { usePublicRaffle } from "../../store/hooks/usePublicRaffle";



export const SuccessPurchasePage = () => {
  const [searchParams] = useSearchParams();

  const { raffle: activeRaffleFounded, needsSelection, isLoading: isLoadingGetActiveRaffle, isUninitialized } = usePublicRaffle(searchParams.get("raffleId"));

  if (needsSelection) {
    return <Navigate to="/" replace />;
  }

  return !isLoadingGetActiveRaffle && !isUninitialized ? (
    <>
      {activeRaffleFounded ? <SuccessPurchase activeRaffle={activeRaffleFounded} /> : <NoActiveRaffle />}
    </>
  ) : <Loading title="Buscando rifas disponibles"></Loading>;
};
